import classNames from 'classnames';
import React from 'react';
import * as styles from './CarouselThumbnailImage.module.scss';
import { useImageSrc } from './ImageNode';
import type { CarouselItem } from './types';

interface CarouselThumbnailImageProps {
  selected: boolean;
  image?: CarouselItem;
}

const CarouselThumbnailImage = ({
  selected,
  image,
}: CarouselThumbnailImageProps) => {
  const src = useImageSrc(image ?? null, { fullscreen: false });

  return (
    <div
      className={classNames(styles.container, {
        [styles.isSelected]: selected,
      })}
    >
      {src ? (
        <img draggable={false} className={styles.thumbnail} src={src} alt="" />
      ) : (
        <div className={styles.placeholder} />
      )}
    </div>
  );
};
export default CarouselThumbnailImage;
